/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Streamers_HeadingInputs */

const ja_playdata_home_streamers_heading = /** @type {(inputs: Playdata_Home_Streamers_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人気ストリーマーを発見・分析`)
};

const en_playdata_home_streamers_heading = /** @type {(inputs: Playdata_Home_Streamers_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover and Analyze Popular Streamers`)
};

/**
* | output |
* | --- |
* | "Discover and Analyze Popular Streamers" |
*
* @param {Playdata_Home_Streamers_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_streamers_heading = /** @type {((inputs?: Playdata_Home_Streamers_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Streamers_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_streamers_heading(inputs)
	return en_playdata_home_streamers_heading(inputs)
});